import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Pencil, Trash2, EyeOff, Video } from "lucide-react";
import { MediaTile } from "@/components/MediaTile";
import { resolveIcon } from "@/lib/iconMap";

export const AdminProductCard = ({ item, onEdit, onDelete }) => {
  const Icon = resolveIcon(item.icon);

  return (
    <div className="card-lux rounded-xl overflow-hidden flex flex-col" data-testid={`admin-product-card-${item.id}`}>
      <div className="relative aspect-square bg-muted overflow-hidden">
        {item.media_url ? (
          <MediaTile
            src={item.media_url}
            mediaType={item.media_type}
            alt={item.name}
            className="absolute inset-0 w-full h-full object-cover"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <Icon className="h-8 w-8 text-primary/50" />
          </div>
        )}
        {item.media_type === "video" && item.media_url && (
          <span className="absolute bottom-2 right-2 h-6 w-6 rounded-full bg-background/80 backdrop-blur flex items-center justify-center border border-primary/30">
            <Video className="h-3 w-3 text-primary" />
          </span>
        )}
        {!item.is_active && (
          <div className="absolute inset-0 bg-background/75 flex items-center justify-center gap-1.5 text-xs text-muted-foreground font-medium">
            <EyeOff className="h-3.5 w-3.5" /> Hidden
          </div>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <p className="font-heading text-sm font-semibold text-foreground truncate" title={item.name}>
          {item.name}
        </p>
        <div className="flex items-center gap-1.5 mt-1.5 flex-wrap min-h-[22px]">
          {item.purity && (
            <Badge variant="outline" className="text-[10px] border-primary/40 text-primary">
              {item.purity}
            </Badge>
          )}
          {item.coming_soon && (
            <Badge variant="outline" className="text-[10px] border-primary/40 text-primary">
              Coming Soon
            </Badge>
          )}
          <span className="text-[10px] text-muted-foreground ml-auto">#{item.display_order}</span>
        </div>
        <div className="flex items-center gap-2 mt-auto pt-3">
          <Button variant="outline" size="sm" className="flex-1" onClick={() => onEdit(item)} data-testid={`admin-edit-btn-${item.id}`}>
            <Pencil className="h-3.5 w-3.5" /> Edit
          </Button>
          <Button variant="destructive" size="sm" onClick={() => onDelete(item)} data-testid={`admin-delete-btn-${item.id}`}>
            <Trash2 className="h-3.5 w-3.5" />
          </Button>
        </div>
      </div>
    </div>
  );
};
